var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},[_c('path',{attrs:{"stroke":"#525D70","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2","d":"m12 10.668 2.666-2.667L12 5.335m-8 0L1.333 8 4 10.668m5.666-8L6.333 13.335"}})])
}
var staticRenderFns = []

export default { render: render }